import React, { useState } from 'react';
import { Alert, AlertTitle, Button, Box } from '@mui/material';
import { Warning, Assignment } from '@mui/icons-material';
import { useSucursal } from '../contexts/SucursalContext';
import ConteoDenominaciones from '../Arqueos/ConteoDenominaciones';

/**
 * Componente para mostrar alerta cuando se requiere conteo de denominaciones
 * NOTA: Actualmente deshabilitado - ya no se requiere validación de conteo
 */
const ConteoDenominacionesAlert = ({ severity = "warning", sx = {} }) => {
    // Ya no mostramos la alerta - el conteo no es obligatorio
    return null;
};

export default ConteoDenominacionesAlert;
